import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../atoms/Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy text-yellow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <Logo variant="horizontal" className="h-10 md:h-12 mb-4" />
          <p className="text-sm text-white/90 max-w-prose">
            DataRook is the company. footyLab is our educational program combining soccer
            and data science.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">Home</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">About Us</Link></li>
              <li><Link to="/footylab" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">footyLab</Link></li>
              <li><Link to="/camp" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">Camps</Link></li>
              <li><Link to="/partners" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">Partners</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li><a href="mailto:info@datarook.com" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">info@datarook.com</a></li>
              <li>Knoxville, TN</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/datarook" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">
                LinkedIn
              </a>
              <a href="https://www.youtube.com/@datarook" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">
                YouTube
              </a>
              <a href="https://www.instagram.com/datarook_official" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300 motion-reduce:transition-none">
                Instagram
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-yellow-600 pt-8 text-center space-y-2">
          <p>&copy; {currentYear} DataRook, Inc. All rights reserved.</p>
          <p>
            <Link
              to="/privacy"
              className="hover:text-white transition-colors duration-300 motion-reduce:transition-none"
            >
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
